<template>
  <v-tabs
    class="mt-3"
    centered
    color="primary"
    next-icon="fa-chevron-right"
    prev-icon="fa-chevron-left"
    show-arrows
    :icons-and-text="$vuetify.breakpoint.smAndUp"
    v-model="activeTab"
  >
    <v-tab v-for="tab in tabs" :key="tab.id" :href="tab.route">
      <span
        v-if="$vuetify.breakpoint.smAndUp"
        class="mt-2"
        v-text="$tc(tab.name, 2)"
      ></span>
      <v-img class="mx-auto" height="35" width="35" :src="tabIcons[tab.name]" />
      <v-icon :medium="$vuetify.breakpoint.smAndUp" v-text="tab.icon" dark />
    </v-tab>
    <v-tabs-items touchless v-model="activeTab">
      <v-tab-item value="tab-dashboard">
        <orders v-if="activeTab === 'tab-dashboard'" />
      </v-tab-item>
      <v-tab-item value="tab-list">
        <list v-if="activeTab === 'tab-list'" />
      </v-tab-item>
      <v-tab-item value="tab-calendar">
        <calendar v-if="activeTab === 'tab-calendar'" />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
import orders from '@/components/dashboard/orders.vue'
import calendar from '@/components/dashboard/calendar.vue'
import list from '@/pages/sale/index.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'dashboard',
  components: {
    orders,
    list,
    calendar
  },
  data() {
    return {
      loading: false,
      activeTab: 'tab-dashboard',
      firstCompany: 0,
      tabs: [
        {
          id: 1,
          name: 'dashboard',
          route: '#tab-dashboard'
        },
        {
          id: 2,
          name: 'list',
          route: '#tab-list'
        },
        {
          id: 3,
          name: 'calendar',
          route: '#tab-calendar'
        }
      ],
      tabIcons: {
        dashboard: require('@/assets/color-icons/dashboard/dashboard.png'),
        list: require('@/assets/color-icons/dashboard/list.png'),
        calendar: require('@/assets/color-icons/dashboard/calendar.png')
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    /**
     * Consulta la información de la empresa actual y actualiza la pestaña
     * activa del dashboard según la configuración recibida desde la API.
     *
     * @author Ing. Argenis Osorio (argenisosorio10 at gmail)
     * @author Angelo Osorio (daniel.321 at gmail)
     */
    async getSettingInfo() {
      this.loading = true
      try {
        const companyData = await this.$api.company.show({
          pk: this.company.pk
        })
        this.activeTab = companyData.data.dashboard
      } catch (error) {
        console.error('No hay información de la empresa en Vuex')
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.getSettingInfo()
  }
}
</script>
